/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cropaspectportrait2Inputs */

const en_cropaspectportrait2 = /** @type {(inputs: Cropaspectportrait2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4:5`)
};

const de_cropaspectportrait2 = /** @type {(inputs: Cropaspectportrait2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`4:5`)
};

/**
* | output |
* | --- |
* | "4:5" |
*
* @param {Cropaspectportrait2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cropaspectportrait2 = /** @type {((inputs?: Cropaspectportrait2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cropaspectportrait2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cropaspectportrait2(inputs)
	return de_cropaspectportrait2(inputs)
});
export { cropaspectportrait2 as "cropAspectPortrait" }